// extracted by mini-css-extract-plugin
module.exports = {"icon":"openHours_icon__3Advj"};